<template>
    <div class="product-view" :class="{'product-view--without-photo': product.groupModifiers.length}">
        <div class="img" :class="{ 'img--contain': product.group === 9 }" :style="{ 'background-image': `url(${product.img.big})` }" :data-alt="product.name">
            <div class="product-label">
                <div v-for="label in product.labels" :key="label" :class="`product-label__item product-label__item--${label}`"></div>
            </div>
        </div>

        <div class="product-info__title">{{ product.name }}</div>

        <div class="product-info">
            <div class="product-info__description">{{ product.desc }}</div>
            <div class="product-info__nutritional-value">Пищевая ценность 1 порции: {{ nutritionalValue }}</div>

            <div class="product-info__modifiers">
                <div v-for="modifier in product.modifiers" v-if="modifier.price !== null">
                    <Modifier :modifier="modifier" />
                </div>
            </div>

            <div class="product-info__group-modifiers">
                <div v-for="groupModifiers in product.groupModifiers">
                    <GroupModifiers v-if="groupModifiers.modifiers.length" :group-modifiers="groupModifiers" />
                </div>
            </div>
        </div>

        <div class="product-footer">
            <div class="product-info__price currency">{{ productPrice }}</div>
            <div class="product-info__meta">{{ product.quantityInProduct }} шт / {{ product.weight.value }}&nbsp{{ product.weight.unit }}</div>
            <product-counter :product="product" :transparent="true" :min="0" :sendInstantly="false" />
            <div class="product-info__add-to-cart btn btn--success" :class="{ 'btn--disabled': !canAddToCart }" @click="canAddToCart ? addToCart() : undefined">Добавить</div>
        </div>
    </div>
</template>

<script>
import GroupModifiers from "./groupModifiers.vue";
import Modifier from "./modifier.vue";

export default {
    name: 'product',
    components: { GroupModifiers, Modifier },
    props: ['product'],

    methods: {
        addToCart() {
            this.$eventBus.$emit('sendCart', {
                type: 'add',
                productId:
                this.product.id,
                count: this.product.count,

                modifiers: this.product.modifiers,
                groupModifiers: this.product.groupModifiers,
            });

            this.$emit('sendCart');
        },

        getAllModifiers() {
            return [...this.product.modifiers.filter((modifier) => modifier.value), ...this.product.groupModifiers.reduce((carry, groupModifiers) => {
                return [...carry, ...groupModifiers.modifiers.filter((modifier) => modifier.value)];
            }, [])];
        }
    },

    computed: {
        nutritionalValue() {
            return [
                `К ${this.product.nutritionalValue100gramm.kkal}`,
                `Б ${this.product.nutritionalValue100gramm.belki}`,
                `Ж ${this.product.nutritionalValue100gramm.zhiry}`,
                `У ${this.product.nutritionalValue100gramm.uglevod}`,
            ].join(', ');
        },

        canAddToCart() {
            return !this.product.groupModifiers.find((groupModifiers) => groupModifiers.groupTotalValue < groupModifiers.min);
        },

        productPrice() {
            return this.product.price + this.getAllModifiers().reduce((carry, modifier) => {
                return carry + modifier.value * modifier.price;
            }, 0);
        },
    },

    mounted() {
        this.product.count = 1;

        this.product.groupModifiers.forEach((groupModifiers) => {
            groupModifiers.modifiers.forEach((modifier) => {
                this.$set(modifier, 'value', 0);
                this.$set(modifier, 'checked', false);
            })
        })
    }
}
</script>
